import logo from "@assets/img/logo/logo-simple.png";
import { config } from "config";
import { FaFacebook, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const navigationItems = [
  { label: "Recursos", target: "recursos" },
  { label: "Modelos", target: "modelos-campanha" },
  { label: "Parceiros", target: "parceiros" },
  { label: "Como funciona", target: "como-funciona" },
];

export default function Footer() {
  const goToSection = (target: string) => {
    document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="footer landing-footer">
      <div className="container landing-footer-content">
        <div className="landing-footer-brand">
          <img
            src={logo}
            alt={config.appName}
            className="landing-footer-logo"
          />
          <strong>{config.appName}</strong>
        </div>

        <nav className="landing-footer-nav" aria-label="Navegação do rodapé">
          {navigationItems.map((item) => (
            <button
              key={item.target}
              type="button"
              onClick={() => goToSection(item.target)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="landing-footer-meta">
          <div className="landing-footer-socials" aria-label="Redes sociais">
            <a
              className="btn px-2"
              href={config.urls.instagram}
              target="_blank"
              title="Instagram"
              aria-label="Instagram"
            >
              <FaInstagram className="fs-4 text-white" />
            </a>
            <a
              className="btn px-2"
              href={config.urls.facebook}
              target="_blank"
              title="Facebook"
              aria-label="Facebook"
            >
              <FaFacebook className="fs-4 text-white" />
            </a>
            <a
              className="btn px-2"
              href={config.urls.youtube}
              target="_blank"
              title="YouTube"
              aria-label="YouTube"
            >
              <FaYoutube className="fs-4 text-white" />
            </a>
            <a
              className="btn px-2"
              href={config.urls.linkedIn}
              target="_blank"
              title="LinkedIn"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn className="fs-4 text-white" />
            </a>
          </div>

          <p className="landing-footer-copyright mb-0">
            {"\u00A9"} {new Date().getFullYear()} {config.appName}, feito por{" "}
            <a
              href={config.made.company.website}
              target="_blank"
              rel="noopener noreferrer"
            >
              {config.made.company.name}
            </a>
            .
            <br />
            Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

